import React, { useState } from 'react';
import { toast } from '../hooks/use-toast';
import { Facebook, Link2, Check, Share2 } from 'lucide-react';

// Inline X (Twitter) icon — lucide's Twitter icon is deprecated
const XIcon = ({ size = 16 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M18.244 2H21.5l-7.5 8.57L23 22h-6.844l-5.36-6.973L4.6 22H1.34l8.02-9.166L1 2h6.98l4.845 6.4L18.244 2Zm-1.2 18h1.9L7.05 4H5.05l11.994 16Z" />
  </svg>
);

/**
 * Share buttons for /psa — Facebook, X (Twitter), and Copy Link.
 * All destinations point at the same shareable /psa URL.
 */
export default function PsaShareButtons() {
  const [copied, setCopied] = useState(false);
  const shareUrl = typeof window !== 'undefined' ? `${window.location.origin}/psa` : '';
  const shareText = "Why Join The Movement? From Consumer to Advocate — a short PSA from Promote Black Business.";

  const openWindow = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer,width=640,height=640');
  };

  const shareFacebook = () => {
    openWindow(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareText)}`);
  };
  const shareX = () => {
    openWindow(`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`);
  };
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast({ title: 'Link copied', description: 'Paste it anywhere to share the PSA.' });
      setTimeout(() => setCopied(false), 2200);
    } catch {
      // Fallback for browsers without clipboard API
      const ta = document.createElement('textarea');
      ta.value = shareUrl;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); setCopied(true); setTimeout(() => setCopied(false), 2200); } catch {}
      document.body.removeChild(ta);
    }
  };

  return (
    <div className="mt-6 rounded-2xl border border-neutral-200 bg-white p-4 sm:p-5" data-testid="psa-share">
      <div className="flex items-center gap-2 text-sm text-neutral-700 font-semibold">
        <Share2 size={14} className="text-green-700"/> Share this PSA
      </div>
      <p className="text-xs text-neutral-500 mt-1">Help one more person move from consumer to advocate.</p>
      <div className="mt-4 flex flex-wrap gap-2">
        <button
          type="button"
          onClick={shareFacebook}
          data-testid="psa-share-facebook"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1877F2] hover:bg-[#166fe0] text-white text-sm font-semibold transition-colors"
          aria-label="Share on Facebook"
        >
          <Facebook size={14}/> Facebook
        </button>
        <button
          type="button"
          onClick={shareX}
          data-testid="psa-share-x"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-neutral-900 hover:bg-neutral-800 text-white text-sm font-semibold transition-colors"
          aria-label="Share on X"
        >
          <XIcon size={14}/> Share on X
        </button>
        <button
          type="button"
          onClick={copyLink}
          data-testid="psa-share-copy"
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-colors ${copied ? 'bg-green-600 text-white' : 'bg-white text-neutral-800 hover:bg-neutral-100 border border-neutral-300'}`}
          aria-label="Copy link to clipboard"
        >
          {copied ? <><Check size={14}/> Copied!</> : <><Link2 size={14}/> Copy link</>}
        </button>
      </div>
    </div>
  );
}
